/* eslint relay/unused-fields: off */
import {useQuery} from '@github-ui/react-query'
import {clientSideRelayFetchQueryRetained} from '@github-ui/relay-environment'
import {graphql, useRelayEnvironment} from 'react-relay'

import type {useLabelsQueryQuery} from './__generated__/useLabelsQueryQuery.graphql'

// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
const LabelPickerGraphqlQuery = graphql`
  query useLabelsQueryQuery($owner: String!, $repo: String!, $labelNames: String = "", $count: Int = 100) {
    repository(owner: $owner, name: $repo) {
      labels(names: $labelNames, first: $count, orderBy: {field: NAME, direction: ASC}) {
        nodes {
          id
          color
          name
          nameHTML
          description
          url
        }
      }
    }
  }
`

export function useLabelsQuery({owner, repo, labels}: {owner?: string; repo?: string; labels?: string[]}) {
  const environment = useRelayEnvironment()

  return useQuery({
    queryKey: ['copilot-immersive-labels', JSON.stringify(environment), owner, repo, labels],
    queryFn: async () => {
      if (!owner || !repo || !labels) return []

      const data = await clientSideRelayFetchQueryRetained<useLabelsQueryQuery>({
        environment,
        query: LabelPickerGraphqlQuery,
        variables: {
          owner,
          repo,
          labelNames: labels.join(','),
          count: labels.length,
        },
      }).toPromise()

      return (data?.repository?.labels?.nodes ?? [])
        .filter(node => !!node)
        .map(node => {
          return node
        })
    },
  })
}
